"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const UserAuthenticationTypeEnum_1 = require("../enums/UserAuthenticationTypeEnum");
class JwtHelper {
    static decode(token) {
        return jsonwebtoken_1.default.decode(token);
    }
    /**
     * Gets the current UserState from a token. This method is deprecated in favor of getUserStateFromToken(),
     * which can be reactive based on a time passed in.
     * @deprecated
     * @param token
     */
    static getUserFromToken(token) {
        console.warn("getUserFromToken(token) is deprecated.");
        return JwtHelper.getUserStateFromToken(token, new Date());
    }
    static getUserStateFromToken(token, currentTime) {
        if (token) {
            let decodedData = JwtHelper.decode(token);
            let fullname = this.IsNullOrWhiteSpace(decodedData.GivenName)
                ? decodedData.Surname
                : `${decodedData.GivenName} ${decodedData.Surname}`;
            let tokenValid = decodedData.exp && ((decodedData.exp - (currentTime.getTime() / 1000)) > 0) ? true : false;
            let result = {
                authenticated: tokenValid,
                username: decodedData.Name,
                givenName: decodedData.GivenName,
                surname: decodedData.Surname,
                fullName: fullname,
                product: decodedData.aud,
                token: token,
                emailAddress: decodedData.EmailAddress,
                roles: typeof (decodedData.roles) === "string" ? [decodedData.roles] : decodedData.roles,
                isAdLogin: decodedData.AuthenticationType === UserAuthenticationTypeEnum_1.UserAuthenticationTypeEnum.AD,
                impersonation: decodedData.Impersonation === 'True'
            };
            return result;
        }
        return {
            authenticated: false,
            token: ''
        };
    }
    static IsNullOrWhiteSpace(str) {
        if (typeof str === 'undefined' || str == null || str.length === 0) {
            return true;
        }
        else {
            return false;
        }
    }
}
exports.JwtHelper = JwtHelper;
//# sourceMappingURL=JwtHelper.js.map